/* eslint-disable */
import Vue from "vue";
import { mappingFunction } from "../../plugins/mappingBaseRef";
import cats from "@/api/categories";
import results from "@/api/results";

const state = {
  results: {},
  resultsPopupTable: {},
  baseGroup: {},
  referenceGroup: {},
  dataTableTopic: "",
  isLoading: false,
  calc: {
    base: 0,
    reference: 0,
  },
  changes: false,
  unsavedChanges: false,
  sizeBaseRef: false,
};

const mutations = {
  setLoadingTrue(state) {
    state.isLoading = true;
  },
  setLoadingFalse(state) {
    state.isLoading = false;
  },
  setTopic(state, subCat) {
    state.dataTableTopic = subCat;
  },
  setSmall(state) {
    state.sizeBaseRef = false;
  },
  toggleSizeBaseRef(state) {
    state.sizeBaseRef = !state.sizeBaseRef;
  },
  saveForLater(state) {
    state.changes = true;
  },
  unsetChanges(state) {
    state.changes = false;
  },
  resetChanges(state) {
    state.unsavedChanges = false;
  },
  resetGroups(state) {
    state.unsavedChanges = false;
    state.baseGroup = {};
    state.referenceGroup = {};
    state.calc.base = 0;
    state.calc.reference = 0;
  },
  // Item is expected as { group: <>, filterName: <>, tagName: <>, variable: <>, checked: true/false }
  addToGroup(state, item) {
    state.unsavedChanges = true;
    const totalValue = item.variable;

    // Create empty object with possible change in filterName array
    let filterNameChange = {};

    // If filter for certain filterName already exists, continue to search whether it already exists.
    if (Object.keys(state[item.group]).indexOf(item.filterName) !== -1) {
      // Check if current filter to be added already exists.
      const itemsFound = state[item.group][item.filterName].filter(
        (filterNameItem) => {
          return (
            filterNameItem.tagName === item.tagName &&
            filterNameItem.value === totalValue
          );
        }
      );

      // If it is not already there, push it to the existing array.
      if (itemsFound.length === 0) {
        filterNameChange[item.filterName] = state[item.group][item.filterName];
        filterNameChange[item.filterName].push({
          tagName: item.tagName,
          value: totalValue,
          checked: true,
        });
      }
    } else {
      // Else create new array as property of change object
      filterNameChange[item.filterName] = [
        { tagName: item.tagName, value: totalValue, checked: true },
      ];
    }

    // Merge old state with new state. Creating new object so that vue reacts to changes.
    state[item.group] = Object.assign({}, state[item.group], filterNameChange);
  },
  // Item is expected as { group: <>, filterName: <>, tagName: <>, value: <> }
  removeFromGroup(state, item) {
    // If filter for certain filterName exists, continue deleting it..
    if (Object.keys(state[item.group]).indexOf(item.filterName) !== -1) {
      const itemIndex = state[item.group][item.filterName].findIndex(
        (filterNameItem) => {
          return (
            filterNameItem.tagName === item.tagName &&
            filterNameItem.value == item.value
          );
        }
      );
      // If an index was found, remove it.
      if (itemIndex !== -1) {
        state[item.group][item.filterName].splice(itemIndex, 1);
      }
      // If property became empty, delete it.
      if (state[item.group][item.filterName].length === 0) {
        // Vue.delete(state[item.group], item.filterName);
        delete state[item.group][item.filterName];
      }
    }
  },
  sendForResults(state, input) {
    state.results = input;
  },
  sendPopupData(state, input) {
    state.resultsPopupTable = input;
  },
};

const actions = {
  addToGroup({ commit, state }, item) {
    commit("addToGroup", item);
    const params = mappingFunction(state.baseGroup, state.referenceGroup);
    commit("setLoadingTrue");
    cats.counter(params).then((res) => {
      let base = res.data.split(",");
      state.calc.base = base[0];
      state.calc.reference = base[1];
      commit("setLoadingFalse");
    });
  },
  removeFromGroup({ commit, state }, item) {
    commit("removeFromGroup", item);
    const params = mappingFunction(state.baseGroup, state.referenceGroup);
    commit("setLoadingTrue");
    cats.counter(params).then((res) => {
      let base = res.data.split(",");
      state.calc.base = base[0];
      state.calc.reference = base[1];
      commit("setLoadingFalse");
    });
  },
  getResults({ commit, state }, category) {
    const params = mappingFunction(state.baseGroup, state.referenceGroup);
    commit("sendForResults", {});
    commit("sendPopupData", {});
    switch (category) {
      case "archetypen":
        results.resultsArchetypes(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "merken":
        results.resultsBrands(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "duurzaamheid":
        results.resultsSustainability(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "lifestyle":
        results.resultsLifestyle(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "media":
        results.resultsMedia(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "overtuigingsstrategieën":
        results.resultsPersuasion(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "politiek":
        results.resultsPolitics(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "demografie":
        results.resultsDemographics(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "overtuigingsstrategieën":
        results.resultsPersuasion(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "onderstromen":
        results.resultsUndercurrent(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "waardekaarten":
        results.resultsValuesCards(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "mentality":
        results.resultsMentality(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "fintality":
        results.resultsFintality(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "shoppermentality":
        results.resultsShopperMentality(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "burgerschapsstijlen":
        results.resultsBurgerschapsstijlen(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "vijftintengroener":
        results.resultsVijfTintenGroener(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "vitality":
        results.resultsVitality(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "zorgmentality":
        results.resultsZorgMentality(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
      case "vrijetijdsprofielen":
        results.resultsVrijetijdsprofielen(params).then((res) => {
          commit("sendForResults", res.data);
          commit("sendPopupData", res.data);
        });
        break;
    }
  },
  getResultsSort({ commit }, data) {
    data.cat, data.pageName;
    const params = mappingFunction(state.baseGroup, state.referenceGroup);
    let saved = {};
    if (data.cat === "") {
      saved = Object.assign({}, params);
    } else {
      saved = Object.assign({}, params, {
        getDataTable: true,
        dataTableTopic: data.cat,
      });
    }
    commit("sendPopupData", {});
    switch (data.pageName) {
      case "merken":
        results.resultsBrandsSort(saved).then((res) => {
          commit("sendPopupData", res.data);
        });
        break;
      case "duurzaamheid":
        results.resultsSustainabilitySort(saved).then((res) => {
          commit("sendPopupData", res.data);
        });
        break;
      case "lifestyle":
        results.resultsLifestyleSort(saved).then((res) => {
          commit("sendPopupData", res.data);
        });
        break;
      case "media":
        results.resultsMediaSort(saved).then((res) => {
          commit("sendPopupData", res.data);
        });
        break;
      case "overtuigingsstrategieën":
        results.resultsPersuasionSort(saved).then((res) => {
          commit("sendPopupData", res.data);
        });
        break;
      case "politiek":
        results.resultsPoliticsSort(saved).then((res) => {
          commit("sendPopupData", res.data);
        });
        break;
      case "demografie":
        results.resultsDemographicsSort(saved).then((res) => {
          commit("sendPopupData", res.data);
        });
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
